import { useEffect, useState } from 'react';
import type { Observable } from 'rxjs';

import { useConstantCallback } from '@motorway/mw-highway-code/hooks';

export const useRxjsStore = <T>(store: Observable<T>, defaultValue: T) => {
  const [state, setState] = useState<T>(defaultValue);
  const stableStore = useConstantCallback(() => store);

  useEffect(() => {
    const subscription = stableStore().subscribe(setState);
    return () => subscription.unsubscribe();
  }, [stableStore]);

  return state;
};
